import { AuthService } from "@/services/AuthService"
import { requestMiddleware } from "./requestMiddleware"
import { ROLES } from "@/services/PermissionsService"
import AccessRules from "@/types/AccessRules"

const ACCESS_RULES: Record<string, AccessRules> = {
  DCA_ROLE: {
    name: "DCA Role",
    shouldApply: () => !!AuthService.getUserRoles().includes(ROLES.DCA),
    allowedRestEndpoints: [
      "/energy_usage_load_factors/alps_range",
      "/api/v1/accounts/*/notes",
      /*
        Both, because ark's single account_contact_updaters endpoint granted
        this role create, update AND cancel — dropping either would be a
        functional regression for DCA users.
      */
      "/accounts/*/contacts",
      "/accounts/*/contacts/*",
      "/payment-method/verify",
      "/accounts/*/direct_debit",
      "/api/v1/accounts/*/update_payment_schedule",
      "/accounts/*/payment-plans",
      "/accounts/*/cancel-payment-plans",
      /*
        Read-only Tariff Quoter postcode searches. They were GETs on ark, which
        this rule never blocks; the backoffice versions are POSTs.
      */
      "/meterpoints/search-mpan",
      "/meterpoints/search-mprn",
    ],
    allowedGraphQLMutations: [],
  },
}

export function initializeAccessRules() {
  Object.values(ACCESS_RULES).forEach((rule) => {
    requestMiddleware.registerAccessRules(rule)
  })
}
